import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header justify-content-center mt-2" }
const _hoisted_2 = { class: "modal-body mx-4" }
const _hoisted_3 = { class: "d-flex justify-content-end m-3 mt-4" }

import i18n from '@/lang/i18n';
import { GDialog } from 'gitart-vue-dialog'
import { computed } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'IgnoreLongTimelongContinuousWarningConfirmationModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function confirm() {
  emits('confirm')
}

function closeModal() {
  emits('cancel')
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_unref(GDialog), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    "max-width": "50%",
    transition: "custom-from-bottom-transition",
    persistent: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: _normalizeClass(props.titleClass)
        }, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.confirmModalTitle')), 3)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(props.noteClass)
        }, _toDisplayString(_unref(i18n).global.t('pages.dailyReports.ignoreLongtimeContinuousWarning.confirmModalBody')), 3)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_btn, {
          class: "ma-2 reset-btn",
          onClick: closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.backBtn')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_btn, {
          class: _normalizeClass(["ma-2 exec-btn", props.confirmBtnClass]),
          onClick: confirm,
          loading: _ctx.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.confirmBtn')), 1)
          ]),
          _: 1
        }, 8, ["class", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})